import { Loader } from "@/components/Loader";
import { Checkbox } from "@/components/ui/checkbox";
import { updateUserIncludeInCalculations } from "@/lib/supabase";
import { UserWithDeals } from "@revelate/types";
import { useState } from "react";
import { KeyedMutator } from "swr";

// NOTE: Database column mapping for active license is "users.include_in_calculations"

export function ActiveLicenseToggle({ user, mutate}: {
  user: UserWithDeals;
  mutate: KeyedMutator<UserWithDeals[]>;
}) {
  const [includeInCalculations, setIncludeInCalculations] = useState<boolean>(user?.include_in_calculations ?? true);
  const [loading, setLoading] = useState<boolean>(false);

  const handleToggle = async () => {
    setLoading(true);

    const updatedUser = await updateUserIncludeInCalculations(user.id, !includeInCalculations);
    if (updatedUser) {
      mutate((users) => {
        if (!users) return users;
        return users.map((u) => (u.id === updatedUser.id ? updatedUser : u));
      }, false);
    }

    setIncludeInCalculations(updatedUser?.include_in_calculations ?? true);
    setLoading(false);
  };

  if (loading) return <Loader size={24} parentClassName="" />

  return (
    <Checkbox checked={includeInCalculations} onCheckedChange={handleToggle} className="w-5 h-5 rounded-[3px]" />
  );
}
